import React from 'react';
import { GetDefaultCurrencySymbol } from '../../../helpers/CommonHelper';
import './ProductAttributes.css';

import { getProductSpecifications } from '../../../helpers/ProductSpecifications';
export { getProductSpecifications } from '../../../helpers/ProductSpecifications';

const SpecificationList = ({ rows }) => (
    <dl className="product-attributes__list">
        {rows.map((row, index) => <div className="product-attributes__row" key={`${row.name}-${index}`}>
            <dt>{row.name}</dt>
            <dd>{row.values.join(', ')}</dd>
        </div>)}
    </dl>
);

export default function ProductAttributes({ description, attributes, selectedVariationId, onSelectVariation, selectedAttributes = [], onSelectAttribute, pricedVariations }) {
    const specifications = getProductSpecifications(description, attributes);
    const rows = specifications.rows;
    const variations = pricedVariations ?? specifications.variations;
    if (!rows.length && !variations.length) return null;
    return <section className="product-attributes" aria-label="Product specifications">
        <h4>Measurements &amp; specifications</h4>
        {rows.length > 0 && <SpecificationList rows={rows} />}
        {variations.length > 0 && onSelectVariation && <fieldset className="product-attributes__choices">
            <legend>Choose a variant</legend>
            <label className="product-attributes__dropdown-label" htmlFor="product-variation-dropdown">Select from dropdown</label>
            <select id="product-variation-dropdown" className="product-attributes__dropdown"
                value={selectedVariationId || ''}
                onChange={event => {
                    const variation = variations.find(item => String(item.id) === event.target.value);
                    if (variation) onSelectVariation(variation);
                }}>
                <option value="">Choose a variant</option>
                {variations.map((variation, index) => {
                    const disabled = !variation.id || variation.price === null || variation.price <= 0 || variation.stock === null || variation.stock <= 0;
                    return <option key={variation.id || index} value={variation.id || ''} disabled={disabled}>
                        {variation.name}{variation.price !== null ? ` — ${GetDefaultCurrencySymbol()}${variation.price.toLocaleString('en-IN', { maximumFractionDigits: 2 })}` : ''}{disabled ? ' (unavailable)' : ''}
                    </option>;
                })}
            </select>
            <div className="product-attributes__variant-strip" aria-label="Available variants">{variations.map((variation, index) => {
                const disabled = !variation.id || variation.price === null || variation.price <= 0 || variation.stock === null || variation.stock <= 0;
                const selected = selectedVariationId === variation.id;
                return <label className={`product-attributes__card${selected ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`} key={variation.id || index}>
                    <span className="product-attributes__card-heading">
                        <input type="radio" name="product-variation" checked={selected} disabled={disabled}
                            onChange={() => { if (!disabled) onSelectVariation(variation); }} />
                        <strong>{variation.name}</strong>
                        {variation.price !== null && <span className="product-attributes__price">{GetDefaultCurrencySymbol()}{variation.price.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>}
                    </span>
                    {variation.rows.length > 0 && <span className="product-attributes__summary">{variation.rows.map(row => `${row.name}: ${row.values.join(', ')}`).join(' · ')}</span>}
                    {variation.stock !== null && variation.stock <= 0 && <span className="product-attributes__stock">Out of stock</span>}
                    {variation.price === null && <span className="product-attributes__stock">Price unavailable</span>}
                    {selected && <span className="product-attributes__selected">Selected</span>}
                </label>;
            })}</div>
        </fieldset>}
        {onSelectAttribute && Array.from(new Set((attributes || []).map(item => item.ProductAttributeID))).map(id => {
            const options = attributes.filter(item => item.ProductAttributeID === id);
            return <fieldset className="product-attributes__choices" key={id}>
                <legend>{options[0].AttributeDisplayName}</legend>
                <div className="product-attributes__pills">{options.map(option => <label key={option.PrimaryKeyValue}>
                    <input type="radio" name={`product-attribute-${id}`} checked={selectedAttributes.some(item => String(item.ProductAttributeID) === String(id) && String(item.PrimaryKeyValue) === String(option.PrimaryKeyValue))}
                        onChange={() => onSelectAttribute(option.PrimaryKeyValue, id)} />
                    <span>{option.PrimaryKeyDisplayValue}{Number(option.AdditionalPrice) !== 0 && Number.isFinite(Number(option.AdditionalPrice)) && ` (${Number(option.AdditionalPrice) > 0 ? '+' : '−'}${GetDefaultCurrencySymbol()}${Math.abs(Number(option.AdditionalPrice)).toLocaleString('en-IN')})`}</span>
                </label>)}</div>
            </fieldset>;
        })}
        {!onSelectVariation && variations.map((variation, index) => <details className="product-attributes__option" key={index}>
            <summary>{variation.name}</summary>
            <SpecificationList rows={variation.rows} />
        </details>)}
    </section>;
}
